import { useCallback, useEffect, useState } from "react";
import { PORTAL_PREP_API } from "../apis/apis";
import { getErr } from "./portalUtils";

/** Preparation resources (training / guides / live trainings) for every enrolled exam. */
export default function usePrep() {
  const [state, setState] = useState({ loading: true, error: null, items: [] });
  const load = useCallback(async () => {
    setState((s) => ({ ...s, loading: true, error: null }));
    try {
      const res = await PORTAL_PREP_API();
      if (res?.status === false) throw new Error(res?.message);
      setState({ loading: false, error: null, items: res?.data || [] });
    } catch (err) {
      setState({ loading: false, error: getErr(err, "Unable to load preparation resources."), items: [] });
    }
  }, []);
  useEffect(() => {
    load();
  }, [load]);
  return { ...state, reload: load };
}
